var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductInfo',{attrs:{"product":_vm.product,"site":_vm.site}}),(_vm.hasPermission('productInventory.view'))?_c('Inventory'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }